import { get } from 'lodash';
import config from './config';
import skin from './skin';

const { theme } = config;
const { breakpointNumeric } = theme;

// at this point make sure the color set up contains all our mandatory fields
const mandatory = ['primary', 'danger', 'warning', 'info', 'success'];

const missing = mandatory.filter(val => !theme.color[val]);
if (missing.length > 0) {
  throw new Error(
    `Colour config not complete, missing the following required definitions: ${missing.join(', ')}`
  );
}

const mobileSmallMax = breakpointNumeric.mobileSmall;
const mobileMax = breakpointNumeric.mobile;
const tabletPortraitMin = breakpointNumeric.mobile + 1;
const tabletPortraitMax = breakpointNumeric.tabletPortrait;
const tabletLandscapeMin = breakpointNumeric.tabletPortrait + 1;
const tabletLandscapeMax = breakpointNumeric.tabletLandscape;
const desktopMin = breakpointNumeric.tabletLandscape + 1;
const desktopMax = breakpointNumeric.desktop;
const desktopLargeMin = breakpointNumeric.desktop + 1;
const desktopWide = breakpointNumeric.sidebarVisibility;

const mediaQuery = {
  mobileOnly: `@media (max-width: ${mobileMax}px)`,
  mobileSmallOnly: `@media (max-width: ${mobileSmallMax}px)`,
  mobilePortraitOnly: `@media (max-width: ${mobileMax}px) and (orientation: portrait)`,
  mobileLandscapeOnly: `@media (max-width: ${mobileMax}px) and (orientation: landscape)`,
  tabletPortraitAndUp: `@media (min-width: ${tabletPortraitMin}px)`,
  tabletPortraitAndBelow: `@media (max-width: ${tabletPortraitMax}px)`,
  tabletPortraitOnly: `@media (min-width: ${tabletPortraitMin}px) and (max-width: ${tabletPortraitMax}px)`,
  tabletLandscapeAndUp: `@media (min-width: ${tabletLandscapeMin}px)`,
  tabletLandscapeAndBelow: `@media (max-width: ${tabletLandscapeMax}px)`,
  tabletLandscapeOnly: `@media (min-width: ${tabletLandscapeMin}px) and (max-width: ${tabletLandscapeMax}px)`,
  desktopAndUp: `@media (min-width: ${desktopMin}px)`,
  desktopOnly: `@media (min-width: ${desktopMin}px) and (max-width: ${desktopMax}px)`,
  desktopLargeOnly: `@media (min-width: ${desktopLargeMin}px)`,
  desktopWide: `@media (min-width: ${desktopWide}px)`,
  pixelDensity2x: '@media (-webkit-min-device-pixel-ratio: 1.5), (min-resolution: 144dpi)',
  internetExplorer: '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)',
  touch: `@media (max-width: ${tabletLandscapeMax}px)`
};

function getSkin(name, alternate) {
  return get(skin, name, alternate);
}

export default Object.assign({}, theme, {
  mediaQuery,
  skin,
  getSkin
});
